/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Type_AllInputs */



/**
* | output |
* | --- |
* | "all" |
*
* @param {Explorer_Search_Type_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_type_all = /** @type {((inputs?: Explorer_Search_Type_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Type_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("all")
	if (locale === "de") return /** @type {LocalizedString} */ ("all")
	if (locale === "it") return /** @type {LocalizedString} */ ("all")
	if (locale === "ru") return /** @type {LocalizedString} */ ("all")
	if (locale === "es") return /** @type {LocalizedString} */ ("all")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("all")
	if (locale === "ja") return /** @type {LocalizedString} */ ("all")
	if (locale === "hi") return /** @type {LocalizedString} */ ("all")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("all")
	return /** @type {LocalizedString} */ ("all")
});